export default {
  getBrowserInfo () {
    var agent = navigator.userAgent.toLowerCase()
    console.log(agent)
    var arr = []
    var system = agent.split(' ')[1].split(' ')[0].split('(')[1]
    arr.push(system)
    var regStrEdge = /edge\/[\d.]+/gi
    var regStrIe = /trident\/[\d.]+/gi
    var regStrFf = /firefox\/[\d.]+/gi
    var regStrChrome = /chrome\/[\d.]+/gi
    var regStrSaf = /safari\/[\d.]+/gi
    var regStrOpera = /opr\/[\d.]+/gi
    // IE
    if (agent.indexOf('trident') > 0) {
      arr.push(agent.match(regStrIe)[0].split('/')[0])
      arr.push(agent.match(regStrIe)[0].split('/')[1])
      return arr[2]
    }
    // Edge
    if (agent.indexOf('edge') > 0) {
      arr.push(agent.match(regStrEdge)[0].split('/')[0])
      arr.push(agent.match(regStrEdge)[0].split('/')[1])
      return arr[2]
    }
    // firefox
    if (agent.indexOf('firefox') > 0) {
      arr.push(agent.match(regStrFf)[0].split('/')[0])
      arr.push(agent.match(regStrFf)[0].split('/')[1])
      return arr[2]
    }
    // Opera
    if (agent.indexOf('opr') > 0) {
      arr.push(agent.match(regStrOpera)[0].split('/')[0])
      arr.push(agent.match(regStrOpera)[0].split('/')[1])
      return arr[2]
    }
    // Safari
    if (agent.indexOf('safari') > 0 && agent.indexOf('chrome') < 0) {
      arr.push(agent.match(regStrSaf)[0].split('/')[0])
      arr.push(agent.match(regStrSaf)[0].split('/')[1])
      return arr[2]
    }
    // Chrome
    if (agent.indexOf('chrome') > 0) {
      arr.push(agent.match(regStrChrome)[0].split('/')[0])
      arr.push(agent.match(regStrChrome)[0].split('/')[1])
      return arr[2]
    } else {
      arr.push('请更换主流浏览器，例如chrome,firefox,opera,safari,IE,Edge!')
      return arr
    }
  },
  getVersion(){
    var agent = navigator.userAgent.toLowerCase()
    var system = agent.split(' ')[1].split(' ')[0].split('(')[1]
    return system
  }
}



// WEBPACK FOOTER //
// ./src/components/utils/getIP.js